export default __webpack_public_path__ + "static/magic-sync-4422aa02dbdc66ae48f8ff7164992bd4.webp";